import axios from 'axios';
import { globalData, globalConf } from "@olmokit/core/data";
import { $, $all, on, forEach, addClass, removeClass } from "@olmokit/dom";
import { updateStepparams, activeStepOnclick, getUrlParamGuest } from "components/Checkout";
import { getUrlQueryParams } from "@olmokit/utils/getUrlQueryParams";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import gsap from "gsap";
gsap.registerPlugin(ScrollToPlugin);
import "./index.scss";
import "./Method/index.scss"

/**
 * Component: CheckoutPayment
 */
export function CheckoutPayment() {
  console.log("CheckoutPayment mounted.");

  const baseUrl = globalConf.baseUrl;
  const cmsApiUrl = globalConf.cmsApiUrl;
  const locale = globalConf.locale;
  const user = globalData.user;
  const cartid = globalData.cartid;
  const acc = $all(".step");

  const guest = getUrlParamGuest();

  const config = {
    headers: {
      ...(!guest) && {"x-token": user.token},
      ...(guest) && {"x-guest": user.token},
      "Content-Type": "application/json"
    }
  };

  const data = {
    code: null,
    cart_id: cartid
  };  

  const $errors = $('.CheckoutShipping:error');
  const $forward = $('#CheckoutPayment:forward');  
  const $methods = $all("[name='paymentmethod']");
  const $el = $('.Addresses:');
  on($forward, 'click', () => {
    
    removeClass(acc[2].nextElementSibling, 'activeStep');
    removeClass(acc[2], 'active');    

    forEach($methods, (method) => {
      if(method.checked){
        data['code'] = method.value;
      }
    });    

    axios.post(cmsApiUrl+'/'+locale+'/shoppingcart/paymentmethod', data, config).then((e) => {
      const { data } = e;
      // addClass(acc[2], 'active');    
      // addClass(acc[2].nextElementSibling, 'activeStep');
      removeClass($errors, 'showError');

      localStorage.setItem("cart-payment", JSON.stringify(data));

      // console.log('data', data);

      const getParams = getUrlQueryParams();
      let param = ''
      if(getParams['token']){
        param = `/?token=${getParams['token']}`
      }

      window.location.href = baseUrl+'/checkout-summary'+param;
    }).catch(error => {

      addClass(acc[2], 'active');
      addClass(acc[2].nextElementSibling, 'activeStep');
      addClass($errors, 'showError');

    });

  });  

  const $backward = $('#CheckoutPayment:backward');
  on($backward, 'click', () => {
    
    addClass(acc[2], 'active');
    addClass(acc[2].nextElementSibling, 'activeStep');    
    activeStepOnclick(2);
    updateStepparams({step: 2});
    removeClass(acc[3], 'active');
    removeClass(acc[3].nextElementSibling, 'activeStep');        
    
    gsap.to(window, { duration: 0.3, scrollTo: { y: acc[2], offsetY: 90 } });

  });
}
